import { arrayOf, oneOf, shape, string } from 'prop-types'

import { ObjectGroupControlFlags } from '../../models/vehicle/object-group-control-flags-enum'
import { ObjectGroupModel } from '../../models/vehicle/object-group-model'
import { ObjectGroupTypes } from '../../models/vehicle/object-group-types-enum'
import { idPropType } from '../common/id-prop-type'

const { CONTROL_FLAGS, NAME, OBJECT_GROUP_ID, OBJECT_GROUP_TYPE } = ObjectGroupModel

/**
 * Note: 'editEventForwardingConfigGroup' is currently the only control flag
 * returned by the API that is nested in the object group object. For all
 * object group flags, see {@see ObjectGroupControlFlags}
 *
 * @typedef {Object} ObjectGroup
 * @property {string} name - The name of the vehicle group
 * @property {Id} objectGroupId - The id of the group
 * @property {string} objectGroupType - Object group type
 * @property {string[]} controlFlags - Array of control flags
 */
export const objectGroupPropType = shape({
    [NAME]: string,
    [OBJECT_GROUP_ID]: idPropType,
    [OBJECT_GROUP_TYPE]: oneOf(Object.values(ObjectGroupTypes)),
    [CONTROL_FLAGS]: arrayOf(oneOf([ObjectGroupControlFlags.EDIT_EVENT_FORWARDING_CONFIG_GROUP]))
})
